// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//import the vue instance
//import Vue from 'vue'
import Vue from 'vue/dist/vue.js';
// Set document title and meta tags with Vue.js
import vueHeadful from 'vue-headful';

//import the App component
import App from './App';

//import the vue router
import VueRouter from 'vue-router';
//tell vue to use the router
Vue.use(VueRouter)

// import the vue resource
import VueResource from 'vue-resource';
Vue.use(VueResource);

// Import stylesheet
import './assets/sass/main.scss';


//import the components
import Home from './components/Home'
import Autor from './components/Autor'
import Obra from './components/Obra'

//define your routes
const routes = [
	//define the root url of the application.
	{ path: '/', component: Home },
  { path: '/autor/:id', name: 'autor', component: Autor },
  { path: '/obra/:autor/:obra', name: 'obra', component: Obra }
]

// Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
  routes, // short for routes: routes
  // mode: 'history'
});

Vue.component('vue-headful', vueHeadful);

//instantiate the vue instance
new Vue({

  el: '#app',

  //pass the template to the root component
  template: '<App/>',

  //declare components that the root component can access
  components: { App },

  //pass in the router to the Vue instance
  router

}).$mount('#app')//mount the router on the app


// WEBPACK FOOTER //
// ./src/main.js